import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function ManagementPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/christof-guenther-ict-management-dach.webp"
      texts={{
        title: "Management",
        heroClaimLine1: "Mit Kompetenz zum Ziel!",
        heroClaimLine2: "",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Management – Christof Günther | NetBasis International"
      metaDescription="Christof Günther begreift B2B Business Development in der DACH-Region als inhabergeführte, strategische Partnerships mit über 30 Jahren ITK-Expertise."
      metaOgUrl="https://net-basis.net/de/ueber-uns/management"
    >
      <div className="flex flex-col md:flex-row md:items-start gap-8 md:gap-12">
        <div className="flex-shrink-0 flex justify-center md:justify-start">
          <div className="w-48 md:w-52 h-auto overflow-hidden rounded-lg border border-background-200">
            <img loading="lazy"
              src="https://net-basis.net/Bilder/CG-Foto.jpg"
              alt="Christof Günther"
              title="Christof Günther - NetBasis International"
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="flex-1 space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
          <h1 className="text-sm md:text-base font-semibold text-foreground-950 font-sans">
            Christof Günther – Gründer, Inhaber und Ihr strategischer Kopf für erfolgreiches B2B Business Development in der DACH-Region.
          </h1>
          <p>
            Gegründet wurde <strong className="text-primary-600">NetBasis International</strong> von ihm Anfang des Jahres 2008 in Düsseldorf und seither inhabergeführt geleitet.
          </p>
          <p>Mit mehr als 30 Jahren fundierter internationaler Erfahrung in der ITK-Branche hilft er ausländischen Herstellern effektiv dabei, mit ihren technologischen Produkten und Lösungen neue Märkte erfolgreich zu erschließen. Sein fachlicher Fokus liegt dabei ganz bewusst auf allen Kernbereichen des strategischen und operativen Business Developments. In enger Zusammenarbeit erarbeitet er für und mit seinen Geschäftspartnern ganzheitliche, zukunftsfähige Markteinführungskonzepte und unterstützt sie zuverlässig bei der praktischen Umsetzung sowie der zielgerichteten Steuerung ihrer gesamten Projektvorhaben.</p>
          <p>Darüber hinaus stellt er interessierten Unternehmen sein tiefes Marktwissen und seine weitreichenden Branchenkenntnisse im Rahmen von spezialisierten Beratungsmandaten sowie durch maßgeschneiderte Trainings und individuelle Coachings zur Verfügung.</p>
          <p>Vor der Gründung von <strong className="text-primary-600">NetBasis International</strong> war Herr Günther über viele Jahre in verantwortungsvollen Führungspositionen – unter anderem als Niederlassungsleiter, Vertriebsleiter und Exportleiter – bei europaweit und weltweit operierenden, mittelständischen Telekommunikations- und IT-Unternehmen tätig. Diese langjährige Management-Expertise bildet das solide Fundament für den nachhaltigen Erfolg Ihrer Auslandsprojekte.</p>
        </div>
      </div>
    </AboutSubPage>
  );
}